import React from "react";
import SpinnerAdmin from "images/spinners/loader-blue.svg";
import SpinnerMerchant from "images/spinners/loader-era.svg";

export type typeLoader = {
  variant?: string;
  size?: number;
};

export const Loader: React.FC<typeLoader> = ({ variant, size }) => {
  let spinner;

  switch (variant) {
    case "admin":
      spinner = SpinnerAdmin;
      break;
    case "merchant":
      spinner = SpinnerMerchant;
      break;
    default:
      spinner = SpinnerMerchant;
  }

  const innerSize = size ? `w-${size} h-${size}` : "h-10 w-10";

  return (
    <div className="absolute inset-0 flex flex-col justify-center items-center rounded-md bg-white bg-opacity-80">
      <div className="inline-block">
        <img
          src={spinner}
          alt="Loading..."
          className={`animate-spin ${innerSize}`}
        />
      </div>
    </div>
  );
};
